import { Container } from "react-bootstrap";
import { isRouteErrorResponse, useNavigate, useRouteError } from "react-router-dom";
import { extractClaims, getDefaultRedirectPath } from "./helpers/AuthorizationManager";
import { authAtom } from "./Data/Atoms";
import { useAtom } from "jotai";

export function ErrorPage() {
  const navigate = useNavigate();
  const [auth] = useAtom(authAtom);
  
  const error = useRouteError();

  console.log(error)

  let httpCode: string | null = null;

  if (isRouteErrorResponse(error)) {
    httpCode = `${error.status} (${error.statusText})`;
  }

  return (
    <Container
      className="d-flex flex-column justify-content-center align-items-center"
      style={{ minHeight: "80vh", textAlign: "center" }}
    >
      <div className="box p-4">
        <div
          style={{
            fontSize: "22px",
            fontWeight: 600,
            marginBottom: "10px",
            color: "#444",
          }}
        >
          Oops!
        </div>

        <div style={{ fontSize: "48px", marginBottom: "20px" }}>⚠️</div>

        <h1 className="mb-2">Unexpected Error</h1>

        {httpCode && (
          <p style={{ fontWeight: "bold", marginBottom: "10px" }}>
            HTTP Code: {httpCode}
          </p>
        )}

        <p className="mb-4">Something went wrong. Please try again later.</p>

        <button
        className="btn btn-primary"
        onClick={() => navigate(getDefaultRedirectPath(extractClaims(auth)))}
        >
        Go back home
        </button>
      </div>
    </Container>
  );
}
